import React from 'react';
import Reflux from 'reflux';
import {withRouter} from 'react-router';
import {Button} from 'antd';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config} from 'Utils';
import {deffDeliveryOffer} from '../../service/reportForm';
import {objectSerial} from 'Utils';
import moment from 'moment';

class DeffDeliveryOfferQuery extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['特殊发运申请报表'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            dateMapTotal: 0,
            searchObj: {
                applyNo: '',
                userName: '',
                receiver: '',
                receiveAddress: '',
                itemDesc: '',
                itemNum: '',
                s: 10,
                p: 1
            },
            loading: false,
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.exportChange = this.exportChange.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }


    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                applyNo: '',
                userName: '',
                receiver: '',
                receiveAddress: '',
                itemDesc: '',
                itemNum: '',
                dateTo: '',
                dateFrom: '',
                s: 10,
                p: 1
            }
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        if (!this.state.searchObj.dateFrom || this.state.searchObj.dateFrom == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.dateTo || this.state.searchObj.dateTo == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/orderReport/deffDeliveryOfferExportExcel?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    dateFrom: value.from,
                    dateTo: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        this.setState({
            loading: true
        });
        deffDeliveryOffer(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    rows: result.data || [],
                    total: result.total,
                    dateMapTotal: result.dataMap ? result.dataMap.total : 0,
                    loading: false
                });
            } else {
                openNotice('error', '数据获取失败', '');
                self.setState({
                    loading: false
                });
            }
        });
    }

    componentWillMount() {
    }

    componentDidMount() {
        // this.initData();
    }

    render() {
        const {opts, key, rows, total, searchObj, dateMapTotal, loading} = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'date',
                    label: '申请时间',
                    options: [
                        {text: '从'},
                        {text: '至'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.dateFrom || '',
                        end: searchObj.dateTo || ''
                    }
                }, {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '请输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                }, {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '请输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                }, {
                    name: 'applyNo',
                    label: '申请编号',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.applyNo
                }, {
                    name: 'userName',
                    label: '申请人',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.userName
                }, {
                    name: 'receiver',
                    label: '收货人',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.receiver
                }, {
                    name: 'receiveAddress',
                    label: '收货地址',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.receiveAddress
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,
            rowKey: 'RN',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            scroll: {x: 3000, y: false},
            columns: [
                {
                    title: '申请编号',
                    dataIndex: 'APPLYNO',
                }, {
                    title: '是否结束',
                    dataIndex: 'ISEND',
                }, {
                    title: '申请人',
                    dataIndex: 'USERNAME',
                }, {
                    title: '申请日期',
                    dataIndex: 'APPLYDATE',
                    render: (text, record, index) => {
                        return <div>{moment(text).format("YYYY-MM-DD")}</div>
                    }
                }, {
                    title: '申请人电话',
                    dataIndex: 'CONTACTTELE',
                }, {
                    title: '物流部门',
                    dataIndex: 'LOGISTICDEPT'
                }, {
                    title: '订单编号',
                    dataIndex: 'ORDERNO',
                }, {
                    title: '客户名称',
                    dataIndex: 'CUSTOMERNAME',
                }, {
                    title: '发货方式',
                    dataIndex: 'CNSHIPMENTWAY',
                }, {
                    title: '所属渠道',
                    dataIndex: 'SALESCHANNEL',
                }, {
                    title: '所属片区',
                    dataIndex: 'BELONGAREA',
                }, {
                    title: '收货人',
                    dataIndex: 'RECEIVER',
                }, {
                    title: '收货电话',
                    dataIndex: 'RCVTELE',
                }, {
                    title: '收货地址',
                    dataIndex: 'RCVADDR',
                }, {
                    title: '预计费用',
                    dataIndex: 'COST',
                }, {
                    title: '物料编码',
                    dataIndex: 'ITEMNUM',
                }, {
                    title: '物料描述',
                    dataIndex: 'ITEMDESC',
                }, {
                    title: '数量',
                    dataIndex: 'ORDERQUANTITY',
                }, {
                    title: '申请说明',
                    dataIndex: 'REMARK',
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}

export default withRouter(DeffDeliveryOfferQuery);



// WEBPACK FOOTER //
// ./src/routes/reportForm/deffDeliveryOfferQuery.js